import { Component } from 'react';

import type { FlowManagerEditModalComponentT, NodeT } from 'fable/flowEditor';

type PropsT<TMNode extends NodeT<string, {}>> =
  FlowManagerEditModalComponentT<TMNode>;

export const noModal = <TMNodeT extends NodeT<string, {}>>(
  nodeType: TMNodeT['nodeType'],
  attributes?: Partial<TMNodeT>,
) => {
  return class NoModal extends Component<PropsT<TMNodeT>> {
    componentDidMount() {
      const nodeOptions = {
        ...this.props.node,
        nodeType,
        isAction: false,
        isRemovable: true,
        isEditable: false,
        payload: {},
        ...attributes,
      } as TMNodeT;

      this.props.replaceNode(nodeOptions);
      this.props.triggerClose();
    }

    render() {
      return null;
    }
  };
};
